<template>
  <!--begin::Wrapper-->
  <div class="w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto">
    <!--begin::Form-->
    <custom-form
      id="kt_login_form"
      ref="formRef"
      autocomplete="none"
      :submit="onSubmitLogin"
      :model="targetData"
      :rules="loginRules"
    >
      <input id="email" name="email" type="email" class="d-none">
      <input id="password" name="password" type="password" class="d-none">
      <!--begin::Heading-->
      <div class="text-center mb-10">
        <!--begin::Title-->
        <h1 class="text-dark mb-0 fs-23px">{{ translate("register.loginToYourAccount") }}</h1>
        <!--end::Title-->
      </div>
      <!--begin::Heading-->

      <!--begin::Social login-->
      <div class="text-center d-flex justify-content-center flex-wrap mb-12">
        <!--begin::Google link-->
        <a
          :href="computedGoogleLink"
          class="btn btn-flex flex-center btn-light btn-lg w-50px h-50px me-13"
        >
          <img
            alt="Logo"
            src="/media/svg/brand-logos/google-icon.svg"
            class="h-25px w-25px"
          />
        </a>
        <!--end::Google link-->

        <!--begin::Google link-->
        <a
          :href="computedFacebookLink"
          class="btn btn-flex flex-center btn-light btn-lg w-50px h-50px me-13"
        >
          <img
            alt="Logo"
            src="/media/svg/brand-logos/facebook-4.svg"
            class="h-25px w-25px"
          />
        </a>
        <!--end::Google link-->

        <!--begin::Google link-->
        <a
          :href="computedAppleLink"
          class="btn btn-flex flex-center btn-light btn-lg w-50px h-50px"
        >
          <img
            alt="Logo"
            src="/media/svg/brand-logos/apple-black.svg"
            class="h-25px w-25px"
          />
        </a>
        <!--end::Google link-->
      </div>
      <!--end::Social login-->

      <!--begin::Separator-->
      <div class="d-flex align-items-center justify-content-center mb-12">
        <div class="border-bottom border-gray-300 mw-32 mw-sm-25 w-100"></div>
        <span class="fw-bold text-gray-400 fs-6 mx-2  text-center text-lowercase white-space-no-wrap">{{
            translate("register.orLoginWithEmail")
          }}</span>
        <div class="border-bottom border-gray-300 mw-32 mw-sm-25 w-100"></div>
      </div>
      <!--end::Separator-->

      <!--begin::Input group-->
      <div class="fv-row mb-5">
        <!--begin::Label-->
        <label class="form-label fs-6 fw-bold text-dark">{{ translate("register.email") }}</label>
        <!--end::Label-->
        <custom-input
          :value="targetData.emailField"
          ref="emailRef"
          name="emailField"
          type="email"
          prop="emailField"
          autocomplete="none"
          @onInput="value => targetData.emailField = value"
        />
      </div>
      <!--end::Input group-->

      <!--begin::Input group-->
      <div class="fv-row mb-12">
        <!--begin::Wrapper-->
        <div class="d-flex flex-stack mb-2">
          <!--begin::Label-->
          <label class="form-label fw-bold text-dark fs-6 mb-0"
          >{{ translate("register.password") }}</label
          >
          <!--end::Label-->

          <!--begin::Link-->
          <router-link :to="{name:'forgot-password'}" class="svg-fill-ios text-hover-primary fs-6 fw-bold" tabindex="-1">
            {{ translate("register.forgotPassword") }}
          </router-link>
          <!--end::Link-->
        </div>
        <!--end::Wrapper-->

        <!--begin::Input-->
        <div class="position-relative">
          <custom-input
            :value="targetData.passwordField"
            name="passwordField"
            type="password"
            prop="passwordField"
            autocomplete="none"
            @onInput="value => targetData.passwordField = value"
          />
        </div>
      </div>
      <!--end::Input group-->

      <!--begin::Actions-->
      <div class="text-center">
        <!--begin::Submit button-->
        <el-form-item>
          <button
            type="submit"
            ref="submitButton"
            id="kt_sign_in_submit"
            class="btn btn-lg btn-primary mb-5 px-24 py-13px"
          >
            <span class="indicator-label">{{ translate("register.loginToAccount") }}</span>

            <span class="indicator-progress">
                        {{ translate("register.pleaseWait") }}
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-2"
                    ></span>
          </span>
          </button>
        </el-form-item>
        <!--end::Submit button-->


      </div>
      <!--end::Actions-->
      <!--begin::Link-->
      <div class="text-gray-400 fw-bold text-center fs-6">
        {{ translate("register.newHere") }}
        <a class="svg-fill-ios text-hover-primary" :href="computedSignUpLink">{{ translate("register.createNewAccount") }}</a>
      </div>
      <!--end::Link-->
    </custom-form>
    <!--end::Form-->
  </div>
  <!--end::Wrapper-->
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SignIn } from '@/components/logics/pages/SignIn';
import { ElFormItem } from 'element-plus';
import CustomInput from '@/components/UI/inputs/CustomInput.vue';
import CustomForm from '@/components/UI/forms/CustomForm.vue';

export default defineComponent({
  name: 'sign-in',
  components: {
    ElFormItem,
    CustomInput,
    CustomForm,
  },
  setup(props, { emit }) {
    return SignIn(props, { emit });
  }
});
</script>
